<vdr-card
    [title]="'customer-validation.title' | translate"
    [ngClass]="isAccountOkay ? 'card card-ok' : 'card card-error'"
>
    <!-- Status geral -->
    <div class="status-header">
        <div class="status-left">
            <span [ngClass]="isAccountOkay ? 'text-green' : 'text-red'">
                <strong>
                    {{
                        isAccountOkay
                            ? ('customer-validation.messages.success'
                              | translate)
                            : ('customer-validation.messages.error' | translate)
                    }}
                </strong>
            </span>
        </div>
    </div>

    <!-- Lista de erros -->
    <div *ngIf="!isAccountOkay && errors.length" class="mt-3">
        <ul class="error-list">
            <li *ngFor="let err of errors" class="error-item">
                <span>
                    {{ 'customer-validation.errors.' + err.type | translate }}
                </span>
                <span class="status-dot bg-red"></span>
            </li>
        </ul>
    </div>
</vdr-card>
